import PasswordReset from './PasswordReset/PasswordReset.vue'
import Vue from "vue";
new Vue({
    el: "#accountReset",
    components: {
        'password-reset' : PasswordReset
    },
    data: () => ({
     
    })

});


// WEBPACK FOOTER //
// ./Scripts/app/AccountReset.js